import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ISubscription, SubscriptionPlan, SubscriptionStatus } from '../../../_models/subscription.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  getPlans(): SubscriptionPlan[] {
    return ['Free', 'Basic Plan', 'Pro Plan', 'Enterprise'];
  }

  getStatuses(): SubscriptionStatus[] {
    return ['Active', 'Inactive', 'Cancelled', 'Expired', 'Pending', 'Free'];
  }

  create(sub: Omit<ISubscription, 'id'>): Observable<ISubscription> {
    const newSub: ISubscription = {
      ...sub,
      id: Math.random().toString(36).substr(2, 9)
    };
    return of(newSub).pipe(delay(500));
  }

  cancel(id: string): Observable<void> {
    return of(undefined).pipe(delay(500));
  }
}
